<template>
  <v-dialog v-model="localShow" max-width="500">
    <v-card>
      <v-card-title :class="isEditing ? 'bg-primary' : 'bg-success'" class="text-white">
        <v-icon class="mr-2">{{ isEditing ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
        {{ isEditing ? 'Edit Operation Type' : 'Add Operation Type' }}
      </v-card-title>
      <v-card-text class="pt-4">
        <v-form ref="form">
          <v-text-field
            v-model="localForm.name"
            label="Name (key) *"
            :rules="[v => !!v || 'Name is required']"
            outlined
            dense
            hint="Internal key (e.g. new, extend, suspend)"
            persistent-hint
          ></v-text-field>

          <v-text-field
            v-model="localForm.label"
            label="Label (display)"
            outlined
            dense
            hint="Display label (e.g. New (Provision), Extend)"
            persistent-hint
            class="mt-2"
          ></v-text-field>

          <v-select
            v-model="localForm.color"
            :items="colorOptions"
            item-value="value"
            item-title="label"
            label="Color"
            outlined
            dense
            class="mt-2"
          >
            <template #item="{ item, props }">
              <v-list-item v-bind="props">
                <template #prepend>
                  <v-chip :color="item.raw.value" size="x-small" class="mr-2">&nbsp;</v-chip>
                </template>
              </v-list-item>
            </template>
            <template #selection="{ item }">
              <v-chip :color="item.raw.value" size="x-small" class="mr-2">&nbsp;</v-chip>
              {{ item.raw.label }}
            </template>
          </v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">
          {{ isEditing ? 'Update' : 'Add' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ServiceOperationTypeDialog',
  props: {
    show: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    formData: { type: Object, default: () => ({}) },
    saving: { type: Boolean, default: false }
  },
  emits: ['close', 'save'],
  data() {
    return {
      localForm: {
        id: null,
        name: '',
        label: '',
        color: 'grey'
      },
      colorOptions: [
        { value: 'success', label: 'Green (success)' },
        { value: 'primary', label: 'Blue (primary)' },
        { value: 'warning', label: 'Orange (warning)' },
        { value: 'info', label: 'Cyan (info)' },
        { value: 'error', label: 'Red (error)' },
        { value: 'grey', label: 'Grey' },
        { value: 'secondary', label: 'Secondary' },
        { value: 'teal', label: 'Teal' }
      ]
    }
  },
  computed: {
    localShow: {
      get() { return this.show },
      set(val) { if (!val) this.$emit('close') }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.localForm = {
          id: this.formData.id || null,
          name: this.formData.name || '',
          label: this.formData.label || '',
          color: this.formData.color || 'grey'
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      if (!this.localForm.name) return
      this.$emit('save', { ...this.localForm })
    }
  }
}
</script>
